// extracted by mini-css-extract-plugin
module.exports = {"ageSelect":"_20jK-C","shine-lines":"atHn4y"};